export const videoFormValidation = {
  personalitiesCredits: 'Etapa 3 - Créditos',
  title: ' Etapa 3 - Título',
  ageRating: 'Etapa 3 - Classificação',
  shortDescription: 'Etapa 3 - Descrição Curta',
  fullDescription: 'Etapa 3 - Descrição Longa',
  targetAudiences: 'Etapa 3 - Publico alvo',
  launchYear: 'Etapa 3 - Ano',
  units: 'Etapa 3 - Unidades (Se o campo canal não estiver preenchido)',
  channels: 'Etapa 3 - Canais (Se o campo unidade não estiver preenchido)',
  thumbnails: 'Etapa 3 - Thumbnails',
  technicalSheet: 'Etapa 3 - Ficha Técnica',
  launchingCountry: 'Etapa 3 - Países de Origem',
  visibility: 'Etapa 7 - Visibilidade da Publicação',
};

export const collecionFormValidation = {
  title: ' Etapa 3 - Título',
  ageRating: 'Etapa 3 - Classificação',
  shortDescription: 'Etapa 3 - Descrição Curta',
  fullDescription: 'Etapa 3 - Descrição Longa',
  targetAudiences: 'Etapa 3 - Publico alvo',
  // launchYear: 'Etapa 3 - Ano',
  // launchingCountry: 'Etapa 3 - Países de Origem',
  units: 'Etapa 3 - Unidades (Se o campo canal não estiver preenchido)',
  channels: 'Etapa 3 - Canais (Se o campo unidade não estiver preenchido)',
  thumbnails: 'Etapa 3 - Thumbnails',
  visibility: 'Etapa 7 - Visibilidade da Publicação',
};
